import logger from "@/utils/logger";

export const API = {
    BASE_URL: process.env.REACT_APP_API_URL,
    IMAGE_DOMAIN: process.env.REACT_APP_IMAGE_DOMAIN
} as const;

// 환경변수 값 로깅
logger.log("API_BASE_URL:", process.env.REACT_APP_API_URL);

export const API_ENDPOINTS = {
    LOGIN: "/api/v1/auth/login",
    REFRESH: "/api/v1/auth/refresh",
    LOGOUT: "/api/v1/auth/logout",
    AUTH: "/api/v1/auth",
    SNS_LOGIN: "/api/v1/auth/sns/sign-in",
    SNS_SIGNUP: "/api/v1/auth/sns/sign-up",
    USER_ME: "/api/v1/users/me",
    ALCOHOLS: "/api/v1/alcohols",
    ALCOHOL_SEARCH: "/api/v1/alcohols/search",
    ALCOHOL_SEARCH_LOG: "/api/v1/alcohols/search-log",
    AROMAS: "/api/v1/aromas",
    MY_REVIEWS: "/api/v1/my-reviews",
    CONTENTS: "/api/v1/contents"
} as const;

// 토큰 관련 상수
export const TOKEN_CONFIG = {
    ACCESS_TOKEN_KEY: "accessToken",
    BUFFER_TIME: 60 * 1000 // 1분 (ms)
} as const;

// API 응답 타입
export interface ApiResponse<T = any> {
    success: boolean;
    data: T;
    message?: string;
    error?: string;
}

// 타입 안전성을 위한 환경변수 타입 선언
interface ImportMetaEnv {
    readonly REACT_APP_API_URL: string;
    readonly REACT_APP_IMAGE_DOMAIN: string;
}

interface ImportMeta {
    readonly env: ImportMetaEnv;
}
